import React, { useRef, useCallback, useLayoutEffect } from 'react';
import '../styles/logo-ticker.css';
import logo_bar1 from '../asset/zentera_logo.webp';

const logos = [
  { image: logo_bar1 },
  { image: logo_bar1 },
  { image: logo_bar1 },
  { image: logo_bar1 },
  { image: logo_bar1 },
  { image: logo_bar1 },

  // { name: 'NNT Bot', icon: '🤖' },
  // { name: 'Global Tech', icon: '🌍' },
  // { name: 'Apex Solutions', icon: '🏔️' },
  // { name: 'Visionary', icon: '👁️' },
  // { name: 'Quantum', icon: '⚛️' },
  // { name: 'Stellar', icon: '⭐' },
];

/** One loop = 50% of track width; same px/s as a ~1400px half-loop in 40s (~35px/s). */
const TICKER_PX_PER_SECOND = 35;

export default function LogoTicker() {
  return (
    <div className="logo-ticker-wrapper">
      {/* Tilted background bar */}
      <div className="logo-ticker-bg-slant"></div>

      {/* Straight foreground bar with logos */}
      <div className="logo-ticker-main-bar">
        <div className="logo-ticker-content">
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="logo-ticker-item">
              <img className="logo-icon" src={logo.image} alt="logo image" width="952" height="514" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
